import { Loading, Flex } from "@100mslive/react-ui";

const FullPageProgress = () => (
  <Flex justify="center" align="center" css={{ size: "100%", backgroundColor: "#F8FAFF" }}>
    <Loading size={100} color="#010C3E" />
  </Flex>
);

export default FullPageProgress;
